if (!customElements.get("variant-dropdown")) {
  customElements.define(
    "variant-dropdown",
    class VariantDropdown extends HTMLElement {
      constructor() {
        super();

        this.dropdownButton = this.querySelector(
          ".wt-product__option__dropdown",
        );
        this.dropdownIcon = this.dropdownButton.querySelector("svg");

        this.container = this.querySelector(".wt-product__option__body");
        this.drawerList = this.querySelector(".drawer__list");

        this.isDropdownOpen = false;
        this.classOpen = "open";
      }

      connectedCallback() {
        this._init();
      }

      openDropdown() {
        this.dropdownIcon.classList.add(this.classOpen);
        this.container.classList.add(this.classOpen);
        this.isDropdownOpen = true;
        this._handleTabindex();
        // Add click outside listener
        document.addEventListener("click", this.handleInteractionOutside);
      }

      closeDropdown() {
        this.container.classList.remove(this.classOpen);
        this.dropdownIcon.classList.remove(this.classOpen);
        this.isDropdownOpen = false;
        this._handleTabindex();
        // Remove click outside listener
        document.removeEventListener("click", this.handleInteractionOutside);
      }

      toggleDropdown() {
        if (this.isDropdownOpen) {
          this.closeDropdown();
        } else {
          this.closeAllOtherDropdowns();
          this.openDropdown();
        }
      }

      // Close any other open dropdowns before opening this one
      closeAllOtherDropdowns() {
        const allDropdowns = document.querySelectorAll("variant-dropdown");
        allDropdowns.forEach((dropdown) => {
          if (dropdown !== this && dropdown.isDropdownOpen) {
            dropdown.closeDropdown();
          }
        });
      }

      handleInteractionOutside(event) {
        if (this.isDropdownOpen) {
          const clickInsideDropdown = this.container.contains(event.target);
          const clickOnButton = this.dropdownButton.contains(event.target);
          const clickOnOption = this.drawerList.contains(event.target);

          // Close if clicked outside dropdown and button, or if clicked on an option
          if ((!clickInsideDropdown && !clickOnButton) || clickOnOption) {
            this.closeDropdown();
          }
        }
      }

      addEventListeners() {
        this.dropdownButton.addEventListener("click", (event) => {
          event.stopPropagation();
          this.toggleDropdown();
        });

        this.container.addEventListener("keydown", this._keyDownHandler);
      }

      removeEventListeners() {
        this.dropdownButton.removeEventListener("click", () => {
          this.toggleDropdown();
        });
        document.removeEventListener("click", this.handleInteractionOutside);
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      getFocusableElements() {
        const focusableElementsSelector =
          "button, [href], input, select, [tabindex]";
        const focusableElements = () =>
          Array.from(
            this.container.querySelectorAll(focusableElementsSelector),
          ).filter((el) => !el.hasAttribute("disabled") && el.tabIndex >= 0);

        return {
          focusableElements,
          first: focusableElements()[0],
          last: focusableElements()[focusableElements().length - 1],
        };
      }

      _handleTabindex() {
        const interactiveElements = this.container.querySelectorAll(
          ".drawer__list__link",
        );

        if (typeof setTabindex === "function") {
          setTabindex(interactiveElements, this.isDropdownOpen ? "0" : "-1");
        } else {
          interactiveElements.forEach((el) => {
            el.setAttribute("tabindex", this.isDropdownOpen ? "0" : "-1");
          });
        }
      }

      _keyDownHandler(e) {
        const isTabPressed =
          e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
        const { first, last } = this.getFocusableElements();

        // Close on Escape
        if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
          if (this.isDropdownOpen) {
            this.closeDropdown();
            this.dropdownButton.focus();
          }
        }

        // Tab trap within dropdown when open
        if (this.isDropdownOpen && isTabPressed) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }

      _init() {
        this.openDropdown = this.openDropdown.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this._keyDownHandler = this._keyDownHandler.bind(this);
        this.handleInteractionOutside = this.handleInteractionOutside.bind(this);

        this._handleTabindex();
        this.addEventListeners();
      }
    },
  );
}